export const getAssistantModels = () => ({
    url: 'ai/v1/models',
    method: 'get',
});
